import * as React from 'react';
import {
    IGroupedComboBoxSubMenuSection,
    isMatchingItem,
    sortMenuItemByOrder,
} from 'grouped-combobox-core';
import {
    IContextualMenuItem,
    ContextualMenuItemType,
    IStyleFunctionOrObject,
} from '@fluentui/react';
import { IGroupedComboBoxButtonProps } from './GroupedComboBoxButton.types';
import {
    IGroupedComboBoxItemStyleProps,
    IGroupedComboBoxItemStyles,
} from '../GroupedComboBox/GroupedComboBox.types';
import { GroupedComboBoxButton } from './GroupedComboBoxButton';

function renderGroupedComboBoxItem(item: IContextualMenuItem): React.ReactNode {
    const buttonProps = item?.data as IGroupedComboBoxButtonProps;
    return <GroupedComboBoxButton {...buttonProps} isSubButton />;
}

const dividerItemProps = {
    styles: {
        divider: { marginLeft: '8px', marginRight: '8px' },
    },
};

export function createSubmenuItems(
    sections: IGroupedComboBoxSubMenuSection[],
    selectedKey: string | undefined,
    styles?: IStyleFunctionOrObject<IGroupedComboBoxItemStyleProps, IGroupedComboBoxItemStyles>
): IContextualMenuItem[] {
    const menuItems: IContextualMenuItem[] = [];
    sections.forEach((section, index) => {
        if (index > 0 && menuItems.length > 0) {
            menuItems.push({
                key: `separator${index}`,
                itemType: ContextualMenuItemType.Divider,
                itemProps: dividerItemProps,
            });
        }

        const hasIcon = section.items.some((item) => item.icon);

        const sectionItems = section.sortByOrder
            ? section.items.sort(sortMenuItemByOrder)
            : section.items;

        menuItems.push(
            ...sectionItems.map<IContextualMenuItem>((item) => {
                // Only set the 'selectedKey' if it matches the sub item key.
                const childSelectedKey = isMatchingItem(item, selectedKey)
                    ? selectedKey
                    : undefined;

                const childButtonProps: IGroupedComboBoxButtonProps = {
                    reserveSpaceForIcon: hasIcon,
                    item,
                    styles,
                    selectedKey: childSelectedKey,
                    animateEntrance: true,
                };

                return {
                    key: item.itemKey,
                    data: childButtonProps,
                    onRender: renderGroupedComboBoxItem,
                };
            })
        );
    });

    return menuItems;
}
